import React, {useEffect, useState} from 'react'

export interface RallyProgressBarProps {
  percentage: number;
  image?: string;
  animate?: boolean;
  imageClassName?: string;
  defaultPercentage?: number;
  hasLessThanIcon?: boolean;
  returnPercentage?: (percentage: number) => void;
}

const RallyProgressBar = ({
  percentage: percent,
  image,
  animate = false,
  imageClassName,
  defaultPercentage,
  hasLessThanIcon = false,
  returnPercentage
}: RallyProgressBarProps) => {
  const [percentage, setPercentage] = useState(0)

  useEffect(() => {
    if (!animate) {
      setPercentage(percent)
      returnPercentage?.(percent)
      return
    }

    const intervalId = setInterval(() => {
      if (percentage >= percent) {
        clearInterval(intervalId)
      } else {
        const newPercentage = percentage + 1
        setPercentage(newPercentage)
        returnPercentage?.(newPercentage)
      }
    }, 50)

    return () => {
      clearInterval(intervalId)
    }
  }, [animate, percentage, percent])

  const animatePercentage = defaultPercentage && defaultPercentage >= percentage ? defaultPercentage : percentage
  const percentageLabel = defaultPercentage && defaultPercentage >= percentage ? `${hasLessThanIcon ? '<' : ''}${defaultPercentage}` : percentage

  return (
    <div className="flex flex-col items-center w-full space-y-5">
      <div className="w-full">
        <div
          className="flex items-center justify-end w-full duration-500 transition-width -mr-1.5 min-w-[60px]"
          style={{width: `${animatePercentage}%`}}
        >
          <label className="text-center text-kwota-primary-600 text-[40px] font-titillium font-semibold leading-[48px]">{`${percentageLabel}%`}</label>
        </div>
      </div>
      <div className="relative w-full h-3 bg-kwota-primary-200 rounded-[10px]">
        <div
          className="h-full bg-kwota-primary-500 rounded-[10px] transition-width duration-500"
          style={{width: `${animatePercentage}%`}}
        ></div>
        <div
          className="absolute inset-y-0 flex items-center justify-end duration-500 transition-width min-w-[66px]"
          style={{width: `${animatePercentage}%`}}
        >
          <img src={image} alt="" className={imageClassName} />
        </div>
      </div>
    </div>
  )
}

export default RallyProgressBar
